import { get, isEmpty } from 'lodash'

const transformToUpdateCourseTypeImageDetailsArgs = data => ({
  image: isEmpty(data.image)
    ? null
    : get(data, 'image[0].originFileObj', undefined),
})

export default transformToUpdateCourseTypeImageDetailsArgs
